module.exports = __webpack_public_path__ + "img/68537c9.jpg";